<template>
  <a-modal
      title="新增自定义轨迹"
      :visible="visible"
      @ok="handleSubmit"
      @cancel="handleCancel"
      width="800px"
  >
    <a-form :form="form" layout="vertical">
      <a-form-item label="订单编号">
        <a-textarea
            v-decorator="['barCodeNos', orderNosRules]"
            placeholder="请输入订单编号，多个编号之间使用enter进行分隔"
            :auto-size="{ minRows: 2, maxRows: 5 }"
            @change="handleOrderNosChange"
        />
      </a-form-item>
      <!-- 轨迹状态 (下拉选择) -->
      <a-form-item label="轨迹状态">
        <a-select
            v-decorator="['trajectoryStatus', trajectoryStatusRules]"
            placeholder="请选择轨迹状态"
        >
          <a-select-option v-for="item in  trajectoryStatusOptions" :key="item.id" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <!-- 轨迹内容 (下拉选择) -->
      <a-form-item label="轨迹内容">
        <a-select
            v-decorator="['triggerNodeKey', orderTrajectoryRules]"
            placeholder="请选择轨迹内容"
        >
          <a-select-option v-for="item in orderTrajectoryOptions" :key="item.id" :value="item.id">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 新增的时间选择器 -->
      <a-form-item label="创建时间">
        <a-date-picker
            v-decorator="['createTime']"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            placeholder="请选择创建时间，未选择默认当前时间"
            style="width: 100%"
        />
      </a-form-item>
      <!-- 是否对客户展示 -->
      <a-form-item label="对客户展示">
        <a-radio-group
            v-decorator="['customerDisplayed', {
            initialValue: 1
          }]"
        >
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
// import MentionInput from '../../../components/MentionInput.vue'
import {
  getAvailableVariables,
  getOrderStatuses,
  getOrderTrajectory,
  batchAddTrajectory
} from "api/trajectory";
import {message} from 'ant-design-vue';
// 提取校验规则到单独的对象
const formRules = {
  barCodeNos: {
    rules: [{
      required: true,
      validator: (rule, value, callback) => {
        if (!value || value.trim().length === 0) {
          callback('请至少输入一个订单编号');
        } else {
          const orders = value.split(/[,，\s]+/).filter(item => item.trim());
          if (orders.length === 0) {
            callback('请至少输入一个有效的订单编号');
          } else {
            callback();
          }
        }
      }
    }]
  },
  trajectoryStatus: {
    rules: [{
      required: true,
      message: '请选择轨迹状态'
    }]
  },
  orderTrajectory: {
    rules: [{
      required: true,
      message: '请选择轨迹内容'
    }]
  }
  // 可以继续添加其他字段的校验规则
};
export default {
  // components: {MentionInput},
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      trajectoryStatusOptions: [],
      orderTrajectoryOptions: [],
      options: [],
      selectedItem: '',
      textareaStr: '',
      // 在data中引用校验规则
      orderNosRules: formRules.barCodeNos,
      trajectoryStatusRules: formRules.trajectoryStatus,
      orderTrajectoryRules: formRules.orderTrajectory,
    }
  },

  created() {
    this.loadOrderStatuses();
    // this.loadOrderTrajectory();
    this.loadVariables();
  },

  methods: {
    // 新增方法：清空 MentionInput 状态
    clearMentionInput() {
      this.selectedItem = '';
      this.textareaStr = '';
      if (this.$refs.mentionInput && this.$refs.mentionInput.clearContent) {
        this.$refs.mentionInput.clearContent();
      }
    },
    handleMentionSelected(selectedBeans) {
      this.selectedItem = selectedBeans;
    },
    handleMentioninputText(inputText) {
      this.textareaStr = inputText;
    },
    // 处理订单编号变化
    handleOrderNosChange(e) {
      const value = e.target.value;
      // 可以在这里处理输入的订单编号，比如去重、格式化等
      // 例如：自动去除多余的空格和分隔符
      const formatted = value.replace(/，/g, ',')  // 中文逗号转英文
          .split(/[,，\s]+/)          // 分割
          .filter(item => item.trim()) // 去空
          .join(', ');                // 重新组合

      // 如果需要可以设置回表单
      this.form.setFieldsValue({
        barCodeNos: formatted
      });
    },
    // 打开弹框
    openModal() {
      this.visible = true
      this.$nextTick(() => {
        this.form.resetFields()
        // 只在弹窗打开时加载一次
        this.loadOrderTrajectory();
      })
    },
    async loadVariables() {
      try {
        const res = await getAvailableVariables();
        this.options = res.data || [];
      } catch (error) {
        console.error('加载可用变量失败:', error);
        message.error('加载可用变量失败');
      }
    },
    // 关闭弹框
    handleCancel() {
      this.visible = false
      this.clearMentionInput();
    },

    // 提交表单
    handleSubmit() {
      // 格式化时间（如果需要）
      this.form.validateFields(async (err, values) => {
        if (err) return;
        const barCodeNoList = values.barCodeNos.split('\n').map(item => item.trim());
        this.modalLoading = true;
        try {
          const params = {
            ...values,
            id: this.currentRecord?.id,
            customerDisplayed: values.customerDisplayed ? 1 : 0,
            triggerNodeKey: values.triggerNodeKey,
            createTime: values.createTime ? values.createTime.format('YYYY-MM-DD HH:mm:ss') : null
          };

          const response = await batchAddTrajectory(params);

          if (response.code == 200) {
            message.success(this.currentRecord ? '更新成功' : '创建成功');
            this.visible = false;
            this.$emit('refresh') // 触发父组件的refresh事件
          } else {
            message.error(response.msg || (this.currentRecord ? '更新失败' : '创建失败'));
          }
        } catch (error) {
          console.error('提交失败:', error);
          message.error('提交失败');
        } finally {
          this.modalLoading = false;
        }
      });
    },

    async loadOrderStatuses() {
      try {
        const res = await getOrderStatuses();
        this.trajectoryStatusOptions = res.data.map(item => ({
          value: item.value,
          label: item.label
        }));
      } catch (error) {
        console.error('加载订单状态失败:', error);
        message.error('加载订单状态失败');
      }
    },
    async loadOrderTrajectory() {
      const param = {
        // triggerMode: 2
      }
      try {
        const res = await getOrderTrajectory(param);
        this.orderTrajectoryOptions = res.data.map(item => ({
          id: item.id,
          label: item.trajectoryTemplate
        }));
      } catch (error) {
        console.error('加载订单状态失败:', error);
        message.error('加载订单状态失败');
      }
    },
  }
}
</script>

<style scoped>
/* 可根据需要添加样式 */
</style>
